import { axios } from "@/lib/axios";
import { useMutation } from "react-query";

interface UpdateAiToolMetricsPayload {
  template_hash: string;
  field_name: string;
}

const updateAiToolMetrics = async (
  payload: UpdateAiToolMetricsPayload
): Promise<number> => {
  const response = await axios.post<number>(`/updateTemplateMetrics`, payload);
  return response.data;
};

export const useUpdateAiToolMetrics = () => {
  return useMutation<number, Error, UpdateAiToolMetricsPayload>(
    updateAiToolMetrics
  );
};
